// DatePickerYearGrid.jsx
export const DatePickerYearGrid = ({ currentYear, onSelectYear }) => {
  const startYear = 1924;
  const endYear = new Date().getFullYear();
  const years = [];
  for (let y = endYear; y >= startYear; y--) years.push(y);

  return (
    <div className="dp-years">
      {years.map((y) => (
        <button
          key={y}
          type="button"
          className={`dp-year-btn ${y === currentYear ? "dp-year-btn--current" : ""}`}
          onClick={() => onSelectYear(y)}
        >
          {y}
        </button>
      ))}
    </div>
  );
};

// DatePickerMonthGrid.jsx
const MONTHS_SHORT = [
  "Ene",
  "Feb",
  "Mar",
  "Abr",
  "May",
  "Jun",
  "Jul",
  "Ago",
  "Sep",
  "Oct",
  "Nov",
  "Dic",
];

export const DatePickerMonthGrid = ({ currentMonth, onSelectMonth }) => (
  <div className="dp-months">
    {MONTHS_SHORT.map((m, i) => (
      <button
        key={m}
        type="button"
        className={`dp-month-btn ${i === currentMonth ? "dp-month-btn--current" : ""}`}
        onClick={() => onSelectMonth(i)}
      >
        {m}
      </button>
    ))}
  </div>
);

export default DatePickerYearGrid;
